var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blank-layout"}},[_c('v-app',[_c('body',{staticClass:"bg-body",attrs:{"id":"kt_body"}},[_c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",style:({
            backgroundImage: `url(${require('@/assets/media/illustrations/sketchy-1/14.png')})`,
          })},[_vm._t("default"),_c('default-footer')],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }